"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.darkTheme = void 0;
var darkTheme_1 = require("./darkTheme");
Object.defineProperty(exports, "darkTheme", { enumerable: true, get: function () { return darkTheme_1.darkTheme; } });
//# sourceMappingURL=index.js.map